import React from "react";

const About = () => {
  return (
    <div>
      <div class="flex md:flex-row flex-col justify-center items-center md:space-x-10 p-10">
        <div class="flex flex-col justify-start">
          <div>
            <h1 class="font-markazi text-5xl">Little Lemon</h1>
            <h2 class="font-markazi text-2xl -mt-3 mb-3">Chicago</h2>
          </div>
          <p class="max-w-xs font-karla md:text-sm text-xs mb-5">
            When cousins Adrian and Mario got together for family gatherings,
            everyone’s bellies were full of laughter and great food. The pair
            each went through their own personal culinary journey and realized
            they made so many people happy when they cooked together. It was at
            that point they decided to open up Little Lemon, a small bistro that
            combined their love of food and family and put these values into a
            small Bistro. The name Little Lemon came from their Grandmother, who
            used to make little lemon cake desserts for them as children, the
            same recipe used in the world famous Lemon Dessert on the menu
            today.
          </p>
        </div>
        <div class="max-w-lg md:w-2/5 w-96 h-[420px] relative overflow-hidden">
          <div class="absolute top-0 md:-right-20 -right-5 w-[65%] lg:w-[75%] max-w-md h-64 overflow-hidden flex justify-center items-center">
            <img
              src="aboutA.jpg"
              alt="Mario and Adrian A"
              class="object-cover w-full h-full object-right-top z-10 drop-shadow-xl shadow-md"
            />
          </div>
          <div class="absolute bottom-0 md:-left-20 -left-10 max-w-md w-[80%] lg:w-[75%] lg:h-64 overflow-hidden flex justify-center items-center">
            <img
              src="aboutB.jpg"
              alt="Mario and Adrian B"
              class="object-cover w-full h-full object-right drop-shadow-xl shadow-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
